export default  [   {
    value: "ALL_VALUE",
    label: "All values"
},  {
    value: "CUSTOM_VALUE",
    label: "Custom value"
}];